import React, { useState, useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import './Css/Programme.css';
import './Css/Programme-responsive.css'

import { Ripple } from "primereact/ripple";
import { confirmDialog } from 'primereact/confirmdialog';
import { Dialog } from 'primereact/dialog';
import { Dropdown, DropdownChangeEvent } from 'primereact/dropdown';
import { Toast } from 'primereact/toast';
import { Button } from "primereact/button";
import { Nullable } from "primereact/ts-helpers";
import { Slider, SliderChangeEvent } from "primereact/slider";
import { Menu } from 'primereact/menu';
import { MenuItem } from 'primereact/menuitem';
import { Skeleton } from "primereact/skeleton";

import ProgramModal from "./ProgramModal";
import ErrorPage from "../../../../../Components/ErrorPage";
import NoDataCreated from "../../../../../Components/NoDataCreated";
import PageLoader from "../../../../../Components/PageLoader";
import DatePicker from "../../../../../Components/DatePicker";
import ProgramChartModal from "./ProgramChartModal";
import { formatDate, parseStringToDate } from "../../../../../Utils/getDate";
import { goToTop } from "../../../../../Components/goToTop";

import { useAppDispatch, useAppSelector } from "../../../../../Controllers/hooks";
import { fetchAllProgramme, fetchAllProgramTemplate, fetchProgrammeChart } from "../../../../../Controllers/Thunks/programmeThunks";
import { ProgramTaskList, ProgramTemplate, ProjectProgramFloor, ProjectProgramTask, Task, TaskLibrary } from "../../../../../Controllers/Types/Project/DefaultService/ProgramInterface";
import { checkNumber, checkPercentage, checkText } from "../../../../../Utils/Validator";
import { taskCreateApi, taskDeleteApi, taskUpdateApi } from "../../../../../Api/Project/DefaultServices/Program/ProgramTaskApi";
import { programTemplateUseApi } from "../../../../../Api/Project/DefaultServices/Program/ProgramApi";
import { useSelector } from "react-redux";
import { RootState } from "../../../../../Controllers/Store";
import { hasPermission } from "../../../../../Controllers/Selectors/permissionsSelector";
import TableActionLoader from "../../../../../Components/TableActionLoader";

const Programme: React.FC = () => {
    const dispatch = useAppDispatch();
    const location = useLocation();
    const projectData = location.state?.data;
    const serviceId = Number(projectData.folder_id);
    // const isShared: boolean = projectData.sharedBy !== null ? true : false;
    const isShared: boolean = projectData.can_edit === false ? true : false;

    const {
        error: dataError, loading: dataLoading, programme,
        projectProgramFloor: projectProgramFloorList,
        projectProgramTask: projectProgramTaskList,
        taskLibrary: taskLibraryList,
        loadingProgramTemplate, errorProgramTemplate, programTemplates,
        loadingProgramChartData, errorProgramChartData, programChartData
    } = useAppSelector((state) => state.programme);

    const [initialDataloading, setInitialDataLoading] = useState<boolean>(true);

    const [selectedProgramTemplate, setSelectedProgramTemplate] = useState<ProgramTemplate | null>(null);
    const [showTemplatesModal, setShowTemplatesModal] = useState<boolean>(false);
    const [showCustomOptionModal, setShowCustomOptionModal] = useState<boolean>(false);
    const [showProgramOptionModal, setShowProgramOptionModal] = useState<boolean>(false);
    const [showProgramTemplateViewModal, setShowProgramTemplateViewModal] = useState<boolean>(false);
    const [showTemplateUse, setShowTemplateUse] = useState<boolean>(false);
    const [startDateForTemplate, setStartDateForTemplate] = useState<Nullable<Date>>(null);
    const [startDateForTemplateError, setStartDateForTemplateError] = useState<string>('');

    const [dataState, setDataState] = useState<'Add' | 'Edit'>('Edit');
    const [programTypeState, setProgramTypeState] = useState<'General' | 'Floor' | null>(null);
    const [showProgramModal, setShowProgramModal] = useState<boolean>(false);

    const toast = useRef<Toast>(null);
    const navigate = useNavigate();
    const [loading, setLoading] = useState<boolean>(false);
    const [taskDeleteLoading, setTaskDeleteLoading] = useState<boolean>(false);

    /* Programme task */
    const [programmeDataByFloor, setProgrammeDataByFloor] = useState<ProjectProgramFloor[]>([]);
    const [programmeDataByTask, setProgrammeDataByTask] = useState<ProjectProgramTask[]>([]);
    const [programmeTaskLibraryData, setProgrammeTaskLibraryData] = useState<TaskLibrary[]>([]);
    const [showProgrammeTaskModal, setShowProgrammeTaskModal] = useState<boolean>(false);

    const [taskName, setTaskName] = useState<TaskLibrary | null>(null);
    const [startDate, setStartDate] = useState<Nullable<Date>>(null);
    const [endDate, setEndDate] = useState<Nullable<Date>>(null);
    const [progress, setProgress] = useState<number>(0);
    const [floorId, setFloorId] = useState<number | null>(null);
    const [editTaskId, setEditTaskId] = useState<number | null>(null);

    const [taskNameError, setTaskNameError] = useState<string>('');
    const [startDateError, setStartDateError] = useState<string>('');
    const [endDateError, setEndDateError] = useState<string>('');
    const [progressError, setProgressError] = useState<string>('');

    const [showTaskProgressModal, setShowTaskProgressModal] = useState<boolean>(false);
    const [showFloorDetailModal, setShowFloorDetailModal] = useState<boolean>(false);
    const [selectedProgrammeTaskDetails, setSelectedProgrammeTaskDetails] = useState<ProjectProgramTask | null>(null);
    const [programmeView, setProgrammeView] = useState<string>('byFloor');
    const [programmeChartView, setProgrammeChartView] = useState<'floor' | 'task' | null>(null);
    const [showProgramChartModal, setShowProgramChartModal] = useState<boolean>(false);
    const programmeViewMenu = useRef<Menu>(null);

    const [showDiplayMessageModal, setShowDiplayMessageModal] = useState<boolean>(false);
    const [selectedProgrameFloorTaskData, setSelectedProgrameFloorTaskData] = useState<Task | null>(null);
    const [selectedProgrameGeneralTaskData, setSelectedProgrameGeneralTaskData] = useState<ProjectProgramTask | null>(null);
    const [programeTaskUpdateHasChanges, setProgrameTaskUpdateHasChanges] = useState<boolean>(false);
    const [taskProgressUpdateHasChanges, setTaskProgressUpdateHasChanges] = useState<boolean>(false);
    const [selectedProgrameFloorData, setSelectedProgrameFloorData] = useState<ProjectProgramFloor | null>(null);

    const useCanEdit = (screen: string, permission: string) => {
        return useSelector((state: RootState) => hasPermission(state, screen, permission));
    };

    const isPermission_progress_options = useCanEdit('Programe', 'progress_options');
    const isPermission_add_program = useCanEdit('Programe', 'add_program');
    const isPermission_edit_program = useCanEdit('Programe', 'edit_program');
    const isPermission_delete_program = useCanEdit('Programe', 'delete_program');
    const isPermission_add_program_task = useCanEdit('Programe', 'add_program_task');
    const isPermission_edit_program_task = useCanEdit('Programe', 'edit_program_task');
    const isPermission_delete_program_task = useCanEdit('Programe', 'delete_program_task');
    const isPermission_change_program_percentage = useCanEdit('Programe', 'change_program_percentage');

    useEffect(() => {
        programDataGet();
    }, [serviceId]);

    /* ********************************* get data list ************************************************** */
    const programDataGet = async () => {
        if (serviceId) {
            await dispatch(fetchAllProgramme(serviceId));
            await dispatch(fetchProgrammeChart(serviceId));
            await dispatch(fetchAllProgramTemplate());
            setInitialDataLoading(false);
        }
    }
    /* ********************************* get data list ************************************************** */


    /****************************************** Program task **************************************/
    useEffect(() => {
        setProgrammeDataByFloor(projectProgramFloorList);
        setProgrammeDataByTask(projectProgramTaskList);
        setProgrammeTaskLibraryData(taskLibraryList);
    }, [projectProgramFloorList, projectProgramTaskList, taskLibraryList]);

    const handleCloseProgrammeTaskModal = () => {
        setShowProgrammeTaskModal(false);
        handleClearFields();
        handleClearErrors();
    }

    const handleClearErrors = () => {
        setTaskNameError('');
        setStartDateError('');
        setEndDateError('');
        setProgressError('');
    }

    const handleClearFields = () => {
        setTaskName(null);
        setStartDate(null);
        setEndDate(null);
        setProgress(0);

        setSelectedProgrameFloorTaskData(null);
        setSelectedProgrameGeneralTaskData(null);
        setSelectedProgrameFloorData(null);
    }

    function showAPIErrorData(keyName: string, error: string): void {
        if (keyName === "project_program_task_library_id") {
            setTaskNameError('The task name is already taken.');
        }
    }

    useEffect(() => {
        checkNumber(taskName?.id || 0, false, setTaskNameError)
    }, [taskName]);

    useEffect(() => {
        checkText(formatDate(startDate!), false, setStartDateError);
    }, [startDate]);

    useEffect(() => {
        checkText(formatDate(endDate!), false, setEndDateError);
    }, [endDate]);

    useEffect(() => {
        checkPercentage(progress, false, setProgressError);
    }, [progress]);

    function checkCredentials(startDateDateOnly: string, endDateDateOnly: string): boolean {
        const isTaskNameValid = checkNumber(taskName?.id || 0, true, setTaskNameError);
        const isStartDateValid = checkText(startDateDateOnly, true, setStartDateError);
        const isEndDateValid = checkText(endDateDateOnly, true, setEndDateError);
        const isProgressValid = checkPercentage(progress, true, setProgressError);

        return isTaskNameValid && isStartDateValid && isEndDateValid && isProgressValid;
    }

    const handleAddProgramTask = (floor?: ProjectProgramFloor | null) => {
        if (floor) {
            setSelectedProgrameFloorData(floor);
            setFloorId(floor?.floor_id);
        } else {
            setSelectedProgrameFloorData(null);
            setFloorId(null);
        }

        setDataState('Add');
        setShowProgrammeTaskModal(true);
    }

    const handleCreateProgrammeTask = async (e: React.FormEvent) => {
        e.preventDefault();

        const startDateDateOnly = formatDate(startDate || null);
        const endDateDateOnly = formatDate(endDate || null);

        if (checkCredentials(startDateDateOnly, endDateDateOnly)) {
            setLoading(true);
            const data = await taskCreateApi(
                programme?.project_program_id || 0,
                floorId || 0,
                taskName?.id || 0,
                startDateDateOnly,
                endDateDateOnly,
                progress
            );

            setLoading(false);

            if (data.statusCode === 200) {
                programDataGet();
                handleCloseProgrammeTaskModal();

                if (toast.current) {
                    toast.current.show({
                        severity: 'success',
                        summary: 'Task added.',
                        detail: 'Task created successfully.',
                        life: 3000
                    });
                }
            } else if (data.statusCode === 422) {
                Object.entries(data.errors ?? []).map(([key, value], index) => (
                    showAPIErrorData(key, value[0])
                ))
            } else {
                if (toast.current) {
                    toast.current.show({
                        severity: 'error',
                        summary: 'Error creating task.',
                        detail: 'There was an error creating the task.',
                        life: 3000
                    });
                }
            }
        }
    }

    const getTaskLibrary = (taskId: number) => {
        const taskLibrary = programmeTaskLibraryData.find((task) => task.id === taskId);
        return taskLibrary ? taskLibrary : null;
    }

    const handleEditProgrammeTask = (data: Task, floor: ProjectProgramFloor) => {
        setDataState('Edit');
        setShowProgrammeTaskModal(true);
        setSelectedProgrameFloorTaskData(data);
        setSelectedProgrameFloorData(floor);

        setEditTaskId(data?.task_id);
        setTaskName(getTaskLibrary(data?.project_program_task_library_id));
        setProgress(data?.progress);
        setStartDate(parseStringToDate(data?.start_date));
        setEndDate(parseStringToDate(data?.end_date));
    }

    const handleUpdateProgrammeTask = async (e: React.FormEvent) => {
        e.preventDefault();

        const startDateDateOnly = formatDate(startDate || null);
        const endDateDateOnly = formatDate(endDate || null);
        if (checkCredentials(startDateDateOnly, endDateDateOnly)) {
            setLoading(true);
            const data = await taskUpdateApi(
                editTaskId || 0,
                taskName?.id || 0,
                "all",
                startDateDateOnly,
                endDateDateOnly,
                progress
            );

            setLoading(false);

            if (data.statusCode === 200) {
                programDataGet();
                handleCloseProgrammeTaskModal();
                if (toast.current) {
                    toast.current.show({
                        severity: 'success',
                        summary: 'Task updated.',
                        detail: 'Task updated successfully.',
                        life: 3000
                    });
                }
            } else if (data.statusCode === 422) {
                Object.entries(data.errors ?? []).map(([key, value], index) => (
                    showAPIErrorData(key, value[0])
                ))
            } else {
                if (toast.current) {
                    toast.current.show({
                        severity: 'error',
                        summary: 'Error updating task.',
                        detail: 'There was an error updating the task.',
                        life: 3000
                    });
                }
            }
        }
    }

    const isTaskAlreadyAdded = (option: TaskLibrary): boolean => {
        if (programme?.program_type === 'Floor') {
            const floorTasks = selectedProgrameFloorData?.task ?? [];

            if (dataState === 'Add') {
                return floorTasks.some(task => task?.project_program_task_library_id === option?.id);
            } else {
                if (selectedProgrameFloorTaskData?.project_program_task_library_id === option?.id) {
                    return false;
                }
                return floorTasks.some(task => task?.project_program_task_library_id === option?.id);
            }
        }

        if (programme?.program_type === 'General') {
            const generalTasks = programmeDataByTask ?? [];

            if (dataState === 'Add') {
                return generalTasks.some(task => task?.task_library_id === option?.id);
            } else {
                if (selectedProgrameGeneralTaskData?.task_library_id === option?.id) {
                    return false;
                }
                return generalTasks.some(task => task?.task_library_id === option?.id);
            }
        }

        return false;
    };

    const taskOptionTemplate = (option: TaskLibrary) => {
        const alreadyAdded = isTaskAlreadyAdded(option);

        return (
            <div className={`task_option_item`}>
                <div>{option.task_name}</div>

                {alreadyAdded && (
                    <div className="text_alert">
                        <i className="bi bi-exclamation-circle me-1"></i>
                        Already added
                    </div>
                )}
            </div>
        );
    };

    const handleDeleteProgrammeTask = () => {
        confirmDialog({
            message: `Are you sure you want to delete the task detail?`,
            header: 'Confirm the deletion',
            icon: 'bi bi-info-circle',
            defaultFocus: 'accept',
            acceptClassName: 'p-button-danger',
            accept: () => deleteProgrammeTask(editTaskId || 0),
            resizable: false,
            draggable: false,
        });
    }

    const deleteProgrammeTask = async (dataId: number) => {
        setTaskDeleteLoading(true);
        const data = await taskDeleteApi(dataId);
        setTaskDeleteLoading(false);

        if (data.statusCode === 200) {
            programDataGet();
            handleCloseProgrammeTaskModal();

            if (toast.current) {
                toast.current.show({
                    severity: 'success',
                    summary: 'Task deleted.',
                    detail: 'Task detail deleted successfully.',
                    life: 3000
                });
            }
        } else {
            if (toast.current) {
                toast.current.show({
                    severity: 'error',
                    summary: 'Error deleting task.',
                    detail: 'There was an error deleting the task.',
                    life: 3000
                });
            }
        }
    }

    /* Modal header */
    const programmeTaskModalHeader = (
        <div className="custom_modal_header_inner">
            <h5 className="modal-title fs-5">
                {dataState === 'Add' ? 'Create new task' : 'Edit task'}
            </h5>
            {dataState === 'Edit' ? (
                <React.Fragment>
                    {taskDeleteLoading ? (
                        <TableActionLoader className="is_modal_loader" />
                    ) : (
                        <React.Fragment>
                            {isPermission_delete_program_task && !isShared && (
                                <button type="button" className="close_modal_btn p-ripple"
                                    onClick={() => handleDeleteProgrammeTask()}>
                                    <i className="bi bi-trash3"></i>
                                    <Ripple />
                                </button>
                            )}
                        </React.Fragment>
                    )}
                </React.Fragment>
            ) : (
                <button type="button" className="close_modal_btn p-ripple"
                    onClick={handleCloseProgrammeTaskModal}>
                    <i className="bi bi-x-circle"></i>
                    <Ripple />
                </button>
            )}
        </div>
    );

    /* Modal footer */
    const programmeTaskModalFooter = (
        <div className="custom_modal_footer">
            <Button
                label="Close"
                className="custom_btn secondary"
                onClick={handleCloseProgrammeTaskModal}
            />

            <Button
                label={loading ? 'Processing' : dataState === 'Add' ? 'Save' : 'Update'}
                onClick={dataState === 'Add' ? handleCreateProgrammeTask : handleUpdateProgrammeTask}
                loading={loading}
                className="custom_btn primary"
                disabled={dataState === 'Edit' && !programeTaskUpdateHasChanges}
            />
        </div>
    );

    const handleProgressChange = (e: SliderChangeEvent) => {
        const value = e.value;
        if (typeof value === 'number') {
            setProgress(value);
        } else {
            setProgress(0);
        }
    };

    /*  */
    const taskDetailHeader = (data: ProjectProgramFloor) => {
        const floorName = data?.floor_name;
        const totalWeekCount = data?.floor_work_date?.total_week_count || 0;

        return (
            <div className="task_detail_header">
                <span className="text_bold data_no_wrap">{floorName}</span>
                <span className="week_count_display">
                    {totalWeekCount} week{totalWeekCount > 1 ? 's' : ''}
                </span>

                <span className="progress_area" style={{ borderColor: getProgressColor(data?.total_progress) }}>
                    <span className="progress_bar"
                        style={{ width: `${data?.total_progress}%`, backgroundColor: getProgressColor(data?.total_progress) }}
                    />
                    <span className="progress_value">
                        {data?.total_progress}%
                    </span>
                </span>
            </div>
        );
    };

    const taskDetailBody = (rowData: Task) => {
        return (
            <div className="prog_task_area">
                <div className="task_img_container">
                    <img src={rowData?.icon_path} alt={rowData?.task_name} />
                </div>
                <h6 className="task_title">{rowData?.task_name}</h6>
            </div>
        );
    };

    const tableActionBody = (rowData: Task, floorData: ProjectProgramFloor) => {
        return (
            <div className="table_action_btn_area task_data_column">
                <button
                    className="data_action_btn primary_table_btn p-ripple"
                    onClick={() => handleEditProgrammeTask(rowData, floorData)}
                >
                    <i className="bi bi-pencil-square"></i>
                    <Ripple />
                </button>
            </div>
        )
    }

    /* Task progress */

    const handleChangeTaskPercentage = (task: Task) => {
        setShowTaskProgressModal(true);

        setEditTaskId(task?.task_id);
        setProgress(task?.progress);
        setSelectedProgrameFloorTaskData(task);
    }

    const handleUpdateTaskProgress = async (e: React.FormEvent) => {
        e.preventDefault();

        if (checkPercentage(progress, true, setProgressError)) {
            setLoading(true);
            const data = await taskUpdateApi(editTaskId || 0, null, "progress", null, null, progress);

            setLoading(false);
            if (data.statusCode === 200) {
                programDataGet();
                handleCloseTaskProgressModal();

                if (toast.current) {
                    toast.current.show({
                        severity: 'success',
                        summary: 'Task progress updated.',
                        detail: 'Task progress updated successfully.',
                        life: 3000
                    });
                }
            } else {
                if (toast.current) {
                    toast.current.show({
                        severity: 'error',
                        summary: 'Error updating task progress.',
                        detail: 'There was an error updating the task progress.',
                        life: 3000
                    });
                }
            }
        }
    }

    const handleCloseTaskProgressModal = () => {
        setShowTaskProgressModal(false);
        setSelectedProgrameFloorTaskData(null);
        setSelectedProgrameGeneralTaskData(null);
        setEditTaskId(null);
        setProgress(0);
    }

    const taskProgressModalHeader = (
        <div className="custom_modal_header_inner">
            <h5 className="modal-title fs-5">
                Change task progress
            </h5>
            <button type="button" className="close_modal_btn p-ripple"
                onClick={handleCloseTaskProgressModal}>
                <i className="bi bi-x-circle"></i>
                <Ripple />
            </button>
        </div>
    );

    const taskProgressModalFooter = (
        <div className="custom_modal_footer">
            <Button
                label="Close"
                className="custom_btn secondary"
                onClick={handleCloseTaskProgressModal}
            />

            <Button
                label={loading ? 'Processing' : 'Update'}
                onClick={handleUpdateTaskProgress}
                loading={loading}
                className="custom_btn primary"
                disabled={!taskProgressUpdateHasChanges}
            />
        </div>
    );

    const handleViewProgramChart = (view: 'floor' | 'task') => {
        setShowProgramChartModal(true);
        setProgrammeChartView(view);
        dispatch(fetchProgrammeChart(serviceId));
    }

    const handleCloseProgramChartModal = () => {
        setShowProgramChartModal(false);
    }

    const programmeViewMenuItems: MenuItem[] = [
        {
            items: [
                {
                    label: 'By floor',
                    command: () => setProgrammeView('byFloor'),
                    template: (item, options) => (
                        <div
                            className={`custom_menu_item ${programmeView === 'byFloor' ? 'active_menu_item' : ''}`}
                            onClick={options.onClick}
                        >
                            {item.label}
                        </div>
                    ),
                },
                {
                    label: 'By task',
                    command: () => setProgrammeView('byTask'),
                    template: (item, options) => (
                        <div
                            className={`custom_menu_item ${programmeView === 'byTask' ? 'active_menu_item' : ''}`}
                            onClick={options.onClick}
                        >
                            {item.label}
                        </div>
                    ),
                },
                {
                    label: 'View by floor Gantt chart',
                    command: () => {
                        handleViewProgramChart('floor');
                        // handleShowDisplaymessage();
                    },
                    template: (item, options) => (
                        <div
                            className={`custom_menu_item ${programmeView === 'floorGanttChart' ? 'active_menu_item' : ''}`}
                            onClick={options.onClick}
                        >
                            {item.label}
                        </div>
                    ),
                },
                {
                    label: 'View by task Gantt chart',
                    command: () => {
                        handleViewProgramChart('task');
                        // handleShowDisplaymessage()
                    },
                    template: (item, options) => (
                        <div
                            className={`custom_menu_item last ${programmeView === 'taskGanttChart' ? 'active_menu_item' : ''}`}
                            onClick={options.onClick}
                        >
                            {item.label}
                        </div>
                    ),
                },
            ],
        },
    ];

    const programmeMenuToggle = (e: React.MouseEvent<HTMLButtonElement>) => {
        programmeViewMenu.current?.toggle(e);
    }

    /* Programme view by task */
    const taskDetailBodyByTask = (data: ProjectProgramTask) => {
        const totalWeekCount = data?.take_work_date?.total_week_count || 0;
        return (
            <div className="prog_task_area align_between">
                <div className="prog_task_sub">
                    <div className="task_img_container">
                        <img src={data?.icon_path} alt={data?.task_name} />
                    </div>
                    <h6 className="task_title">{data?.task_name}</h6>
                </div>
                <span className="week_count_display">
                    {totalWeekCount} week{totalWeekCount > 1 ? 's' : ''}
                </span>
            </div>
        );
    };

    const tableActionBodyByTask = (rowData: ProjectProgramTask) => {
        return (
            <div className="table_action_btn_area task_data_column">
                <button className="data_action_btn p-ripple"
                    onClick={() => handleViewFloorDetails(rowData)}>
                    <i className="bi bi-chevron-right"></i>
                    <Ripple />
                </button>
            </div>
        )
    }


    /* Floor detail */
    const handleViewFloorDetails = (data: ProjectProgramTask) => {
        setShowFloorDetailModal(true);
        setSelectedProgrammeTaskDetails(data);
    }

    const handleCloseFloorDetailModal = () => {
        setShowFloorDetailModal(false);
    }

    const floorDetailModalHeader = (
        <div className="custom_modal_header_inner">
            <h5 className="modal-title fs-5">
                View detail
            </h5>
            <button type="button" className="close_modal_btn p-ripple"
                onClick={handleCloseFloorDetailModal}>
                <i className="bi bi-x-circle"></i>
                <Ripple />
            </button>
        </div>
    );

    const getProgressColor = (percentage: number) => {
        if (percentage === 100) {
            return '#32BB6D';
        } else if (percentage > 0) {
            return '#FFBE00';
        } else {
            return '#DDDDDD';
        }
    };

    const getCircleCircumference = (radius: number) => {
        const circleCircumference = 2 * Math.PI * radius;
        return circleCircumference;
    }

    const getCircleOffset = (percentage: number, radius: number) => {
        const circleCircumference = 2 * Math.PI * radius;
        const offset = circleCircumference - (percentage / 100) * circleCircumference;

        return offset;
    }


    /* for ganttChart view */
    const handleShowDisplaymessage = () => {
        setShowDiplayMessageModal(true);
    }
    /* ***************************************************************************************** */


    /* Common function */
    const goBack = () => {
        navigate(-1);
        goToTop();
    };
    /*  */


    /* *************************************************************************** */
    const handleShowProgramOption = () => {
        setShowProgramOptionModal(true);
    }

    const handleCloseProgramOptionModal = () => {
        setShowProgramOptionModal(false);
    }

    const programOptionModalHeader = (
        <div className="custom_modal_header_inner">
            <h5 className="modal-title fs-5">
                Program create with
            </h5>
            <button type="button" className="close_modal_btn p-ripple"
                onClick={handleCloseProgramOptionModal}>
                <i className="bi bi-x-circle"></i>
                <Ripple />
            </button>
        </div>
    );
    /*  */

    /* Program template */
    const handleShowTemplatesModal = () => {
        setShowTemplatesModal(true);
        setShowProgramOptionModal(false);
    }

    const handleCloseTemplatesModal = () => {
        setShowTemplatesModal(false);
        setShowProgramOptionModal(true);
    }

    const templatesModalHeader = (
        <div className="custom_modal_header_inner">
            <h5 className="modal-title fs-5">
                Program templates
            </h5>
            <button type="button" className="close_modal_btn p-ripple"
                onClick={handleCloseTemplatesModal}>
                <i className="bi bi-x-circle"></i>
                <Ripple />
            </button>
        </div>
    );

    const handleCloseProgramTemplateViewModal = () => {
        setShowProgramTemplateViewModal(false);
        setShowTemplatesModal(true);
        setSelectedProgramTemplate(null);
        handleCloseUseTemplate();
    }

    const handleSelectProgramTemplate = (template: ProgramTemplate) => {
        setShowProgramTemplateViewModal(true);
        setShowTemplatesModal(false);
        setSelectedProgramTemplate(template);
    }

    const templateViewModalHeader = (
        <div className="custom_modal_header_inner">
            <h5 className="modal-title fs-5">
                Template detail
            </h5>
            <button type="button" className="close_modal_btn p-ripple"
                onClick={handleCloseProgramTemplateViewModal}>
                <i className="bi bi-x-circle"></i>
                <Ripple />
            </button>
        </div>
    );

    const templateTaskDetailBody = (rowData: ProgramTaskList) => {
        return (
            <div className="prog_task_area">
                <div className="task_img_container">
                    <img src={rowData?.common_icon?.path ?? ''} alt={rowData?.task_name} />
                </div>
                <h6 className="task_title">{rowData?.task_name}</h6>
            </div>
        );
    };


    /* Use template */
    const handleUseTemplate = () => {
        setShowTemplateUse(prev => !prev);
    }

    const handleCloseUseTemplate = () => {
        setShowTemplateUse(false);
        setStartDateForTemplate(null);
        setStartDateForTemplateError('');
    }

    function checkCredentialsTemplateUse(startDateString: string): boolean {
        const isStartDateValid = checkText(startDateString, true, setStartDateForTemplateError);

        return isStartDateValid;
    }

    const handleCreateProgramWithTemplate = async (e: React.FormEvent) => {
        e.preventDefault();

        const folder_id: number = serviceId || 0;
        const template_program_id: number = selectedProgramTemplate?.id || 0;
        const start_date = formatDate(startDateForTemplate || null);

        if (checkCredentialsTemplateUse(start_date)) {
            setLoading(true);
            const data = await programTemplateUseApi(
                folder_id,
                template_program_id,
                start_date
            );

            setLoading(false);

            if (data.statusCode === 200) {
                programDataGet();
                handleCloseUseTemplate();
                setShowProgramTemplateViewModal(false);
                setSelectedProgramTemplate(null);

                if (toast.current) {
                    toast.current.show({
                        severity: 'success',
                        summary: 'Program created.',
                        detail: 'The program was successfully created using the template.',
                        life: 3000
                    });
                }
            } else if (data.statusCode === 422) {
                Object.entries(data.errors ?? []).map(([key, value], index) => (
                    showAPIErrorData(key, value[0])
                ))
            } else {
                if (toast.current) {
                    toast.current.show({
                        severity: 'error',
                        summary: 'Error creating program.',
                        detail: 'There was an error creating the progam using template.',
                        life: 3000
                    });
                }
            }
        }
    }
    /*  */

    /* Program custom */
    const handleShowCustomOption = () => {
        setShowCustomOptionModal(true);
        setShowProgramOptionModal(false);
    }

    const handleCloseCustomOptionModal = () => {
        setShowCustomOptionModal(false);
        setShowProgramOptionModal(true);
    }

    const customOptionModalHeader = (
        <div className="custom_modal_header_inner">
            <h5 className="modal-title fs-5">
                Select program type
            </h5>
            <button type="button" className="close_modal_btn p-ripple"
                onClick={handleCloseCustomOptionModal}>
                <i className="bi bi-x-circle"></i>
                <Ripple />
            </button>
        </div>
    );
    /*  */

    /*  */
    const handleAddProgram = (type: 'General' | 'Floor') => {
        setShowProgramModal(true);
        setShowCustomOptionModal(false);
        setProgramTypeState(type);
        setDataState('Add');
    }

    const handleEditProgram = () => {
        const programtype = programme?.program_type;
        setDataState('Edit');
        setProgramTypeState(programtype || null);
        setShowProgramModal(true);
    }

    const handleCloseProgrammeModal = () => {
        setShowProgramModal(false);
        setProgramTypeState(null);
    }

    const handleExitProgrammeModal = () => {
        setShowProgramModal(false);
        setProgramTypeState(null);

        if (dataState === 'Add') {
            setShowCustomOptionModal(true);
        }
    }

    /* General */
    const handleEditGeneralProgrammeTask = (data: ProjectProgramTask) => {
        setDataState('Edit');
        setShowProgrammeTaskModal(true);
        setSelectedProgrameGeneralTaskData(data);

        setEditTaskId(data?.task_id);
        setTaskName(getTaskLibrary(data?.task_library_id));
        setProgress(data?.total_progress);
        setStartDate(parseStringToDate(data?.take_work_date?.start_date));
        setEndDate(parseStringToDate(data?.take_work_date?.end_date));
    }

    const tableActionBodyGeneral = (rowData: ProjectProgramTask) => {
        return (
            <div className="table_action_btn_area task_data_column">
                <button
                    className="data_action_btn primary_table_btn p-ripple"
                    onClick={() => handleEditGeneralProgrammeTask(rowData)}
                >
                    <i className="bi bi-pencil-square"></i>
                    <Ripple />
                </button>
            </div>
        )
    }

    const handleChangeTaskPercentageGeneral = (task: ProjectProgramTask) => {
        setShowTaskProgressModal(true);

        setEditTaskId(task?.task_id);
        setProgress(task?.total_progress);
        setSelectedProgrameGeneralTaskData(task);
    }

    useEffect(() => {
        if (programme?.program_type === 'Floor') {
            if (selectedProgrameFloorTaskData) {
                if (taskName?.id !== selectedProgrameFloorTaskData?.project_program_task_library_id) {
                    setProgrameTaskUpdateHasChanges(true);
                } else if (formatDate(startDate!) !== selectedProgrameFloorTaskData?.start_date) {
                    setProgrameTaskUpdateHasChanges(true);
                } else if (formatDate(endDate!) !== selectedProgrameFloorTaskData?.end_date) {
                    setProgrameTaskUpdateHasChanges(true);
                } else if (progress !== selectedProgrameFloorTaskData?.progress) {
                    setProgrameTaskUpdateHasChanges(true);
                } else {
                    setProgrameTaskUpdateHasChanges(false);
                }
            }
        } else if (programme?.program_type === 'General') {
            if (selectedProgrameGeneralTaskData) {
                if (taskName?.id !== selectedProgrameGeneralTaskData?.task_library_id) {
                    setProgrameTaskUpdateHasChanges(true);
                } else if (formatDate(startDate!) !== selectedProgrameGeneralTaskData?.take_work_date?.start_date) {
                    setProgrameTaskUpdateHasChanges(true);
                } else if (formatDate(endDate!) !== selectedProgrameGeneralTaskData?.take_work_date?.end_date) {
                    setProgrameTaskUpdateHasChanges(true);
                } else if (progress !== selectedProgrameGeneralTaskData?.total_progress) {
                    setProgrameTaskUpdateHasChanges(true);
                } else {
                    setProgrameTaskUpdateHasChanges(false);
                }
            }
        }
    }, [programme, selectedProgrameFloorTaskData, selectedProgrameGeneralTaskData, taskName, startDate, endDate, progress])


    useEffect(() => {
        if (programme?.program_type === 'Floor') {
            if (selectedProgrameFloorTaskData) {
                if (progress !== selectedProgrameFloorTaskData?.progress) {
                    setTaskProgressUpdateHasChanges(true);
                } else {
                    setTaskProgressUpdateHasChanges(false);
                }
            }
        } else if (programme?.program_type === 'General') {
            if (selectedProgrameGeneralTaskData) {
                if (progress !== selectedProgrameGeneralTaskData?.total_progress) {
                    setTaskProgressUpdateHasChanges(true);
                } else {
                    setTaskProgressUpdateHasChanges(false);
                }
            }
        }
    }, [programme, selectedProgrameFloorTaskData, selectedProgrameGeneralTaskData, progress])


    return (
        <React.Fragment>
            <Toast ref={toast} />

            <div className="main_content layout_padding show_side_bar">
                {dataLoading && initialDataloading ? (
                    <PageLoader />
                ) : dataError ? (
                    <ErrorPage errorMessage={dataError} />
                ) : (
                    <div className="page_content mt-0">
                        <div className="page_breadcrumb_area">
                            <ul className="page_breadcrumb">
                                <li className="page_breadcrumb_item has_child has_link" onClick={() => navigate(-1)}>
                                    {projectData.job_number} : {projectData.address}
                                </li>
                                <li className="page_breadcrumb_item has_child">
                                    {projectData.folder}
                                </li>
                                <li className="page_breadcrumb_item active">
                                    {projectData.feature_name}
                                </li>
                            </ul>

                            <button className="back_btn p-ripple" onClick={goBack}>
                                <i className="bi bi-arrow-left me-2"></i>
                                Back
                                <Ripple />
                            </button>
                        </div>

                        {!programme || Object.keys(programme).length === 0 ? (
                            <React.Fragment>
                                <div className="page_header_area justify-content-end mt-sm-2">
                                    {isPermission_add_program && !isShared && (
                                        <div className="page_action_area gap-2">
                                            <button className="add_data_link_btn p-ripple" onClick={handleShowProgramOption}>
                                                <i className="bi bi-plus-circle"></i>
                                                <span>Add Program</span>
                                                <Ripple />
                                            </button>
                                        </div>
                                    )}
                                </div>

                                <div className="page_main_content_section">
                                    <NoDataCreated
                                        message={`No ${(projectData.feature_name).toLowerCase()} data available. ${!isShared && isPermission_add_program ? 'To add the program click on add button.' : ''}`}
                                    />
                                </div>
                            </React.Fragment>
                        ) : (
                            <React.Fragment>
                                {programme?.program_type === 'Floor' ? (
                                    <React.Fragment>
                                        <div className="project_details_head_area with_custom_flex mt-3">
                                            <div className="project_details_content_area">
                                                <div className="project_details_content_title pt-0">
                                                    <h6>
                                                        <span>{programme?.program_name}</span>
                                                    </h6>

                                                    {isPermission_edit_program && !isShared && (
                                                        <button className="edit_button p-ripple" onClick={handleEditProgram}>
                                                            <i className="bi bi-pencil-square"></i>
                                                            Edit
                                                            <Ripple />
                                                        </button>
                                                    )}
                                                </div>

                                                <div className="project_details_content_tags pb-0">
                                                    <p>{programme?.for}</p><span className="devider">|</span>
                                                    <p>{programme?.no_of_basement}&nbsp;Basement(s)</p><span className="devider">|</span>
                                                    <p>{programme?.no_of_floor}&nbsp;Floor(s)</p><span className="devider">|</span>
                                                    <p>Date :&nbsp;
                                                        {programme?.program_date?.start && programme?.program_date?.end ? (
                                                            <React.Fragment>
                                                                {programme?.program_date?.start ? programme?.program_date?.start : '---'}
                                                                &nbsp; - &nbsp;
                                                                {programme?.program_date?.end ? programme?.program_date?.end : '---'}
                                                            </React.Fragment>
                                                        ) : '-----'}
                                                    </p><span className="devider">|</span>
                                                    <p>Months :&nbsp;
                                                        {programme?.program_finish_month || programme?.program_full_month ? (
                                                            <React.Fragment>
                                                                {programme?.program_finish_month ? programme?.program_finish_month : '0'}
                                                                &nbsp;/&nbsp;
                                                                {programme?.program_full_month ? programme?.program_full_month : '0'}
                                                            </React.Fragment>
                                                        ) : '0'}
                                                    </p>
                                                </div>
                                            </div>

                                            <div className="programme_btn_grp">
                                                <button className="add_data_link_btn fill p-ripple"
                                                    onClick={() => navigate('/project/detail/default-service/onsite/programe/task', { state: { data: projectData } })}>
                                                    <span>Task name</span>
                                                    <Ripple />
                                                </button>
                                                <div>
                                                    <button className="is_btn dot_btn p-ripple"
                                                        onClick={(e) => programmeMenuToggle(e)}
                                                        aria-controls="popup_menu_left"
                                                        aria-haspopup>
                                                        <i className="bi bi-three-dots-vertical"></i>
                                                        <Ripple />
                                                    </button>
                                                    <Menu model={programmeViewMenuItems} popup ref={programmeViewMenu}
                                                        id="popup_menu_left" className="service_action_menu programme_menu" />
                                                </div>
                                            </div>
                                        </div>

                                        {programmeView === 'byFloor' ? (
                                            <div className="page_main_content_section">
                                                {programmeDataByFloor?.length > 0 ? (
                                                    <React.Fragment>
                                                        {programmeDataByFloor?.map((data) => {
                                                            return (
                                                                <React.Fragment>
                                                                    {data?.task && data?.task?.length > 0 ? (
                                                                        <div key={data?.floor_id} className="programme_content_section">
                                                                            <div className="table-responsive">
                                                                                <table className="table table-sm program_table">
                                                                                    <thead>
                                                                                        <tr className="program_table_row">
                                                                                            <th style={{ width: '47%' }}>
                                                                                                {taskDetailHeader(data)}
                                                                                            </th>
                                                                                            <th className="text-secondary prog_data_head"
                                                                                                style={{ width: '15%' }}>
                                                                                                Start date
                                                                                            </th>
                                                                                            <th className="text-secondary prog_data_head"
                                                                                                style={{ width: '15%' }}>
                                                                                                End date
                                                                                            </th>
                                                                                            <th className="text-secondary prog_data_head text-center"
                                                                                                style={{ width: '15%' }}>
                                                                                                Percentage
                                                                                            </th>

                                                                                            {isPermission_edit_program_task && !isShared && (
                                                                                                <th style={{ width: '8%' }}></th>
                                                                                            )}
                                                                                        </tr>
                                                                                    </thead>
                                                                                    <tbody>
                                                                                        {data?.task.map((task) => {
                                                                                            return (
                                                                                                <tr className="program_table_row left_border" style={{ backgroundColor: task?.color_code }}>
                                                                                                    <td style={{ width: '47%' }}>
                                                                                                        {taskDetailBody(task)}
                                                                                                    </td>
                                                                                                    <td style={{ width: '15%' }}>
                                                                                                        <div className="prog_data_container data_no_wrap text-secondary">
                                                                                                            {task?.start_date ? task.start_date : '--'}
                                                                                                        </div>
                                                                                                    </td>
                                                                                                    <td style={{ width: '15%' }}>
                                                                                                        <div className="prog_data_container data_no_wrap text-secondary">
                                                                                                            {task?.end_date ? task.end_date : '--'}
                                                                                                        </div>
                                                                                                    </td>
                                                                                                    <td style={{ width: '15%' }}>
                                                                                                        <div className={`prog_data_container text-center text-secondary data_no_wrap p-ripple pointable ${(!isPermission_change_program_percentage || isShared) && ' disabled'}`}
                                                                                                            onClick={() => isPermission_change_program_percentage && !isShared ? handleChangeTaskPercentage(task) : null} >
                                                                                                            {task?.progress ? task.progress : '0'}%
                                                                                                            <Ripple />
                                                                                                        </div>
                                                                                                    </td>
                                                                                                    {isPermission_edit_program_task && !isShared && (
                                                                                                        <td style={{ width: '8%' }}>
                                                                                                            {tableActionBody(task, data)}
                                                                                                        </td>
                                                                                                    )}
                                                                                                </tr>
                                                                                            )
                                                                                        })}
                                                                                    </tbody>

                                                                                    {isPermission_add_program_task && !isShared && (
                                                                                        <tfoot>
                                                                                            <tr className="program_table_row left_border footer_row">
                                                                                                <td colSpan={isPermission_edit_program_task && !isShared ? 5 : 4}>
                                                                                                    <Button label="Add more task"
                                                                                                        onClick={() => handleAddProgramTask(data)}
                                                                                                        className="custom_btn primary prog_btn mt-1 mb-1"
                                                                                                        icon="bi bi-plus-circle"
                                                                                                    />
                                                                                                </td>
                                                                                            </tr>
                                                                                        </tfoot>
                                                                                    )}
                                                                                </table>
                                                                            </div>
                                                                            <hr className="border-secondary" />
                                                                        </div>
                                                                    ) : (
                                                                        <div key={data?.floor_id} className="programme_content_section">
                                                                            <h6 className="programme_title">{data?.floor_name}</h6>

                                                                            {isPermission_add_program_task && !isShared ? (
                                                                                <Button label="Add new task"
                                                                                    onClick={() => handleAddProgramTask(data)}
                                                                                    className="custom_btn primary prog_btn"
                                                                                    icon="bi bi-plus-circle"
                                                                                />
                                                                            ) : (
                                                                                <table className="table table-sm program_table">
                                                                                    <tfoot>
                                                                                        <tr className="program_table_row left_border footer_row">
                                                                                            <td>
                                                                                                <small>
                                                                                                    <i className="bi bi-exclamation-circle me-1"></i>
                                                                                                    No task added.
                                                                                                </small>
                                                                                            </td>
                                                                                        </tr>
                                                                                    </tfoot>
                                                                                </table>
                                                                            )}

                                                                            <hr className="border-secondary" />
                                                                        </div>
                                                                    )}
                                                                </React.Fragment>
                                                            )
                                                        })}
                                                    </React.Fragment>
                                                ) : (
                                                    <NoDataCreated
                                                        message={`No data found!`}
                                                    />
                                                )}
                                            </div>
                                        ) : programmeView === 'byTask' ? (
                                            <div className="page_main_content_section">
                                                {programmeDataByTask?.length > 0 ? (
                                                    <div className="programme_content_section">
                                                        <div className="table-responsive">
                                                            <table className="table table-sm program_table">
                                                                <thead>
                                                                    <tr className="program_table_row">
                                                                        <th style={{ width: '47%' }}></th>
                                                                        <th className="text-secondary prog_data_head"
                                                                            style={{ width: '15%' }}>
                                                                            Start date
                                                                        </th>
                                                                        <th className="text-secondary prog_data_head"
                                                                            style={{ width: '15%' }}>
                                                                            End date
                                                                        </th>
                                                                        <th className="text-secondary prog_data_head text-center"
                                                                            style={{ width: '15%' }}>
                                                                            Percentage
                                                                        </th>
                                                                        <th style={{ width: '8%' }}></th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    {programmeDataByTask?.map((task) => {
                                                                        return (
                                                                            <tr className="program_table_row left_border" style={{ backgroundColor: task?.color_code }}>
                                                                                <td style={{ width: '47%' }}>
                                                                                    {taskDetailBodyByTask(task)}
                                                                                </td>
                                                                                <td style={{ width: '15%' }}>
                                                                                    <div className="prog_data_container data_no_wrap text-secondary">
                                                                                        {task?.take_work_date.start_date ? task.take_work_date.start_date : '--'}
                                                                                    </div>
                                                                                </td>
                                                                                <td style={{ width: '15%' }}>
                                                                                    <div className="prog_data_container data_no_wrap text-secondary">
                                                                                        {task?.take_work_date.end_date ? task.take_work_date.end_date : '--'}
                                                                                    </div>
                                                                                </td>
                                                                                <td style={{ width: '15%' }}>
                                                                                    <div className="prog_data_container text-center text-secondary data_no_wrap">
                                                                                        {task?.total_progress ? task.total_progress : '0'}%
                                                                                    </div>
                                                                                </td>
                                                                                <td style={{ width: '8%' }}>
                                                                                    {tableActionBodyByTask(task)}
                                                                                </td>
                                                                            </tr>
                                                                        )
                                                                    })}
                                                                </tbody>
                                                            </table>
                                                        </div>
                                                    </div>
                                                ) : (
                                                    <NoDataCreated
                                                        message={`No data found!`}
                                                    />
                                                )}
                                            </div>
                                        ) : null}
                                    </React.Fragment>
                                ) : programme?.program_type === 'General' ? (
                                    <React.Fragment>
                                        <div className="project_details_head_area with_custom_flex mt-3">
                                            <div className="project_details_content_area">
                                                <div className="project_details_content_title pt-0">
                                                    <h6>
                                                        <span>{programme?.program_name}</span>
                                                    </h6>

                                                    {isPermission_edit_program && !isShared && (
                                                        <button className="edit_button p-ripple" onClick={handleEditProgram}>
                                                            <i className="bi bi-pencil-square"></i>
                                                            Edit
                                                            <Ripple />
                                                        </button>
                                                    )}
                                                </div>

                                                <div className="project_details_content_tags pb-0">
                                                    <p>{programme?.for}</p><span className="devider">|</span>
                                                    <p>Date :&nbsp;
                                                        {programme?.program_date?.start && programme?.program_date?.end ? (
                                                            <React.Fragment>
                                                                {programme?.program_date?.start ? programme?.program_date?.start : '---'}
                                                                &nbsp; - &nbsp;
                                                                {programme?.program_date?.end ? programme?.program_date?.end : '---'}
                                                            </React.Fragment>
                                                        ) : '-----'}
                                                    </p><span className="devider">|</span>
                                                    <p>Months :&nbsp;
                                                        {programme?.program_finish_month || programme?.program_full_month ? (
                                                            <React.Fragment>
                                                                {programme?.program_finish_month ? programme?.program_finish_month : '0'}
                                                                &nbsp;/&nbsp;
                                                                {programme?.program_full_month ? programme?.program_full_month : '0'}
                                                            </React.Fragment>
                                                        ) : '0'}
                                                    </p>
                                                </div>
                                            </div>

                                            <div className="programme_btn_grp">
                                                <button className="add_data_link_btn fill p-ripple"
                                                    onClick={() => navigate('/project/detail/default-service/onsite/programe/task', { state: { data: projectData } })}>
                                                    <span>Task name</span>
                                                    <Ripple />
                                                </button>
                                            </div>
                                        </div>

                                        <div className="page_main_content_section">
                                            {programmeDataByTask?.length > 0 ? (
                                                <div className="programme_content_section">
                                                    <div className="table-responsive">
                                                        <table className="table table-sm program_table">
                                                            <thead>
                                                                <tr className="program_table_row">
                                                                    <th style={{ width: '47%' }}></th>
                                                                    <th className="text-secondary prog_data_head"
                                                                        style={{ width: '15%' }}>
                                                                        Start date
                                                                    </th>
                                                                    <th className="text-secondary prog_data_head"
                                                                        style={{ width: '15%' }}>
                                                                        End date
                                                                    </th>
                                                                    <th className="text-secondary prog_data_head text-center"
                                                                        style={{ width: '15%' }}>
                                                                        Percentage
                                                                    </th>

                                                                    {isPermission_edit_program_task && !isShared && (
                                                                        <th style={{ width: '8%' }}></th>
                                                                    )}
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {programmeDataByTask?.map((task) => {
                                                                    return (
                                                                        <tr className="program_table_row left_border" style={{ backgroundColor: task?.color_code }}>
                                                                            <td style={{ width: '47%' }}>
                                                                                {taskDetailBodyByTask(task)}
                                                                            </td>
                                                                            <td style={{ width: '15%' }}>
                                                                                <div className="prog_data_container data_no_wrap text-secondary">
                                                                                    {task?.take_work_date.start_date ? task.take_work_date.start_date : '--'}
                                                                                </div>
                                                                            </td>
                                                                            <td style={{ width: '15%' }}>
                                                                                <div className="prog_data_container data_no_wrap text-secondary">
                                                                                    {task?.take_work_date.end_date ? task.take_work_date.end_date : '--'}
                                                                                </div>
                                                                            </td>
                                                                            <td style={{ width: '15%' }}>
                                                                                <div className={`prog_data_container text-center text-secondary data_no_wrap p-ripple pointable ${(!isPermission_change_program_percentage || isShared) && ' disabled'}`}
                                                                                    onClick={() => isPermission_change_program_percentage && !isShared ? handleChangeTaskPercentageGeneral(task) : null} >
                                                                                    {task?.total_progress ? task.total_progress : '0'}%
                                                                                    <Ripple />
                                                                                </div>
                                                                            </td>

                                                                            {isPermission_edit_program_task && !isShared && (
                                                                                <td style={{ width: '8%' }}>
                                                                                    {tableActionBodyGeneral(task)}
                                                                                </td>
                                                                            )}
                                                                        </tr>
                                                                    )
                                                                })}
                                                            </tbody>

                                                            {isPermission_add_program_task && !isShared && (
                                                                <tfoot>
                                                                    <tr className="program_table_row left_border footer_row">
                                                                        <td colSpan={isPermission_edit_program_task && !isShared ? 5 : 4}>
                                                                            <Button label="Add more task"
                                                                                onClick={() => handleAddProgramTask(null)}
                                                                                className="custom_btn primary prog_btn mt-1 mb-1"
                                                                                icon="bi bi-plus-circle"
                                                                            />
                                                                        </td>
                                                                    </tr>
                                                                </tfoot>
                                                            )}
                                                        </table>
                                                    </div>
                                                </div>
                                            ) : (
                                                <div className="no_data_created_area with_pointing">
                                                    <img src="/assets/images/no_data/no_data_img.png" alt="No Data Found!" />
                                                    <h6>
                                                        No task added!
                                                    </h6>

                                                    {isPermission_add_program_task && !isShared && (
                                                        <button className="add_data_link_btn fill radius p-ripple" onClick={() => handleAddProgramTask(null)}>
                                                            <i className="bi bi-plus-circle"></i>
                                                            <span>Add new task</span>
                                                            <Ripple pt={{ root: { style: { background: "rgba(164, 96, 253, 0.2)" } } }} />
                                                        </button>
                                                    )}
                                                </div>
                                            )}
                                        </div>
                                    </React.Fragment>
                                ) : null}
                            </React.Fragment>
                        )}
                    </div>
                )}
            </div>


            {/* Program modal */}
            <ProgramModal
                dataState={dataState}
                isOpen={showProgramModal}
                type={programTypeState!}
                onClose={handleCloseProgrammeModal}
                onCancel={handleExitProgrammeModal}
                onFetchData={programDataGet}
                toast={toast}
                serviceId={serviceId}
                programme={programme}
            />

            {/* Task progress modal */}
            <Dialog
                visible={showTaskProgressModal}
                header={taskProgressModalHeader}
                footer={taskProgressModalFooter}
                headerClassName="custom_modal_header"
                className="custom_modal_dialog modal_dialog_sm"
                onHide={handleCloseTaskProgressModal}
                dismissableMask
            >
                <div className="custom_modal_body">
                    <div className="p-1 p-sm-4 pt-sm-3 pb-sm-0 w-100">
                        <div className="row">
                            <div className="col-12">
                                <div className="page_form_group">
                                    <label htmlFor="progress" className="custom_form_label">Change the percentage</label>
                                    <div className="progress_display">
                                        <h6>Progress:</h6>
                                        <span>{progress}%</span>
                                    </div>
                                    <Slider
                                        value={progress}
                                        min={0}
                                        max={100}
                                        onChange={handleProgressChange}
                                        step={1}
                                        className="w-14rem custom_progress_bar"
                                    />

                                    {progressError &&
                                        <small className="form_error_msg mt-3">{progressError}</small>
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Dialog>
            {/*  */}


            {/* Floor detail modal */}
            <Dialog
                visible={showFloorDetailModal}
                header={floorDetailModalHeader}
                headerClassName="custom_modal_header"
                className="custom_modal_dialog modal_dialog_sm"
                onHide={handleCloseFloorDetailModal}
                dismissableMask
            >
                <div className="custom_modal_body">
                    {selectedProgrammeTaskDetails && (
                        <div className="row">
                            <div className="col-12">
                                <h5 className="task_view_head">{selectedProgrammeTaskDetails?.task_name}</h5>
                                <div className="circular_progress_container">
                                    <svg width="120" height="120" className="circular_progress">
                                        <circle
                                            className="background_circle"
                                            cx="60"
                                            cy="60"
                                            r="50"
                                            strokeWidth="6"
                                        />
                                        <circle
                                            className="inner_circle"
                                            cx="60"
                                            cy="60"
                                            r="37"
                                            strokeWidth="1"
                                            stroke={getProgressColor(selectedProgrammeTaskDetails?.total_progress)}
                                        />
                                        <circle
                                            className="progress_circle"
                                            cx="60"
                                            cy="60"
                                            r="50"
                                            strokeWidth="6"
                                            strokeLinecap="round"
                                            strokeDasharray={getCircleCircumference(50)}
                                            strokeDashoffset={getCircleOffset(selectedProgrammeTaskDetails?.total_progress, 50)}
                                            stroke={getProgressColor(selectedProgrammeTaskDetails?.total_progress)}
                                        />
                                        <text x="50%" y="50%" textAnchor="middle" dy=".3em" className="progress_text">
                                            {selectedProgrammeTaskDetails?.total_progress}%
                                        </text>
                                    </svg>
                                </div>
                                {selectedProgrammeTaskDetails?.take_work_date && (
                                    <h6 className="task_view_sub_head">{selectedProgrammeTaskDetails?.take_work_date.start_date_2} - {selectedProgrammeTaskDetails?.take_work_date.end_date_2}</h6>
                                )}
                            </div>

                            {selectedProgrammeTaskDetails?.floor && selectedProgrammeTaskDetails?.floor?.length > 0 && (
                                <div className="col-12 mt-2">
                                    {selectedProgrammeTaskDetails?.floor?.map((floor, index) => {
                                        return (
                                            <div key={index} className="row mb-2">
                                                <div className="col-sm-9 col-8 pe-1">
                                                    <div className="floor_data_container">
                                                        <p>{floor?.floor_name}</p>
                                                        <h6>{floor?.start_date_2 + ' - ' + floor?.end_date_2}</h6>
                                                        <p>{floor?.week_count}&nbsp;week{floor?.week_count > 1 ? 's' : ''}</p>
                                                    </div>
                                                </div>
                                                <div className="col-sm-3 col-4 ps-1">
                                                    <div className="floor_progress_container">
                                                        <svg width="70" height="70" className="circular_progress">
                                                            <circle
                                                                className="background_circle"
                                                                cx="35"
                                                                cy="35"
                                                                r="30"
                                                                strokeWidth="4.5"
                                                            />
                                                            <circle
                                                                className="inner_circle"
                                                                cx="35"
                                                                cy="35"
                                                                r="22"
                                                                strokeWidth="1"
                                                                stroke={getProgressColor(floor?.progress)}
                                                            />
                                                            <circle
                                                                className="progress_circle"
                                                                cx="35"
                                                                cy="35"
                                                                r="30"
                                                                strokeWidth="4.5"
                                                                strokeLinecap="round"
                                                                strokeDasharray={getCircleCircumference(30)}
                                                                strokeDashoffset={getCircleOffset(floor?.progress, 30)}
                                                                stroke={getProgressColor(floor?.progress)}
                                                            />
                                                            <text x="50%" y="50%" textAnchor="middle" dy=".3em" className="progress_text small">
                                                                {floor?.progress}%
                                                            </text>
                                                        </svg>
                                                    </div>
                                                </div>
                                            </div>
                                        )
                                    })}
                                </div>
                            )}
                        </div>
                    )}
                </div>
            </Dialog>
            {/*  */}


            {/* Task modal */}
            <Dialog
                visible={showProgrammeTaskModal}
                header={programmeTaskModalHeader}
                footer={programmeTaskModalFooter}
                headerClassName="custom_modal_header"
                className="custom_modal_dialog modal_dialog_md"
                onHide={handleCloseProgrammeTaskModal}
                dismissableMask
            >
                <div className="custom_modal_body">
                    <div className="p-1 p-sm-4 pt-sm-3 pb-sm-0 w-100">
                        <div className="row">
                            <div className="col-12">
                                <div className="page_form_group">
                                    <label htmlFor="programmeTask" className="custom_form_label is_required">Task name</label>
                                    <Dropdown
                                        id="programmeTask"
                                        value={taskName}
                                        onChange={(e: DropdownChangeEvent) => setTaskName(e.value)}
                                        options={programmeTaskLibraryData}
                                        optionLabel="task_name"
                                        itemTemplate={taskOptionTemplate}
                                        placeholder="Select task"
                                        className="form_dropdown w-100"
                                        filter
                                        optionDisabled={(option: TaskLibrary) => isTaskAlreadyAdded(option)}
                                        filterPlaceholder="Search by task name"
                                        showClear
                                    />

                                    {taskNameError &&
                                        <small className="form_error_msg">{taskNameError}</small>
                                    }
                                </div>
                            </div>

                            <div className="col-12 col-sm-6">
                                <DatePicker
                                    id="startDate"
                                    label="Start date"
                                    labelHtmlFor="startDate"
                                    required={true}
                                    value={startDate}
                                    placeholder="dd/mm/yyyy"
                                    onChange={setStartDate}
                                    error={startDateError}
                                    showClear
                                    onClear={() => setStartDate(null)}
                                />
                            </div>

                            <div className="col-12 col-sm-6">
                                <DatePicker
                                    id="endDate"
                                    label="End date"
                                    labelHtmlFor="endDate"
                                    required={true}
                                    value={endDate}
                                    minDate={startDate!}
                                    placeholder="dd/mm/yyyy"
                                    onChange={setEndDate}
                                    error={endDateError}
                                    showClear
                                    inputDisabled={startDate === null && true}
                                    onClear={() => setEndDate(null)}
                                />
                            </div>

                            <div className="col-12 col-sm-6 mx-auto">
                                <div className="page_form_group">
                                    <label htmlFor="progress" className="custom_form_label is_required">Set the percentage</label>
                                    <div className="progress_display">
                                        <h6>Progress:</h6>
                                        <span>{progress}%</span>
                                    </div>
                                    <Slider
                                        value={progress}
                                        min={0}
                                        max={100}
                                        step={1}
                                        onChange={handleProgressChange}
                                        className="w-14rem custom_progress_bar"
                                        disabled={!isPermission_change_program_percentage}
                                    />

                                    {progressError &&
                                        <small className="form_error_msg mt-3">{progressError}</small>
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Dialog >
            {/*  */}


            {/* Program option modal */}
            <Dialog
                visible={showProgramOptionModal}
                header={programOptionModalHeader}
                headerClassName="custom_modal_header"
                className="custom_modal_dialog modal_dialog_xsm"
                onHide={handleCloseProgramOptionModal}
                dismissableMask
                draggable={false}
            >
                <div className="custom_modal_body">
                    <div className="custom_option_btn_area">
                        <button className="custom_pc_option_btn p-ripple"
                            onClick={handleShowTemplatesModal}>
                            <span>
                                <i className="bi bi-ui-checks-grid me-2"></i>
                                Template
                            </span>
                            <i className="bi bi-chevron-right"></i>
                            <Ripple />
                        </button>

                        <button className="custom_pc_option_btn p-ripple"
                            onClick={handleShowCustomOption}>
                            <span>
                                <i className="bi bi bi-pencil-square me-2"></i>
                                Custom
                            </span>
                            <i className="bi bi-chevron-right"></i>
                            <Ripple />
                        </button>
                    </div>
                </div>
            </Dialog>
            {/*  */}


            {/* Template options modal */}
            <Dialog
                visible={showTemplatesModal}
                header={templatesModalHeader}
                headerClassName="custom_modal_header"
                className="custom_modal_dialog modal_dialog_md"
                onHide={handleCloseTemplatesModal}
                dismissableMask
            >
                <div className="custom_modal_body">
                    <div className="plan_check_templates_area">
                        {errorProgramTemplate ? (
                            <div className="feature_not_available_area">
                                <h6>
                                    <i className="bi bi-exclamation-circle me-1"></i>
                                    An error occurred while retrieving program templates.
                                </h6>
                            </div>
                        ) : (
                            <React.Fragment>
                                {programTemplates && programTemplates?.length > 0 ? (
                                    <React.Fragment>
                                        <h6 className="plan_check_template_head">Choose a template:</h6>
                                        <div className="row sow_template_row">
                                            {loadingProgramTemplate ? (
                                                <React.Fragment>
                                                    {[...Array(4)].map((_, index) => (
                                                        <div className="col-12 col-sm-6 col-lg-6" key={index}>
                                                            <Skeleton className="sow_template_loading">
                                                                <Skeleton className="temp_icon_loading" />
                                                                <div className="w-100">
                                                                    <Skeleton className="temp_title_loading" />
                                                                    <Skeleton width="80px" height="10px" className="temp_title_loading mt-2" />
                                                                </div>
                                                            </Skeleton>
                                                        </div>
                                                    ))}
                                                </React.Fragment>
                                            ) : (
                                                <React.Fragment>
                                                    {programTemplates?.map((template) => (
                                                        <div key={template?.id} className="col-12 col-sm-6 col-lg-6">
                                                            <article className="sow_template p-ripple" style={{ backgroundColor: template?.color_code || '#EEE' }}
                                                                onClick={() => handleSelectProgramTemplate(template)}>
                                                                <div className="temp_icon">
                                                                    <img src={template?.logo_path || ''} alt={template?.program_name} />
                                                                </div>
                                                                <div className="sow_template_sub">
                                                                    <h6>{template?.program_name}</h6>
                                                                    <p>{template?.program_type}</p>
                                                                </div>
                                                                <Ripple />
                                                            </article>
                                                        </div>
                                                    ))}
                                                </React.Fragment>
                                            )}
                                        </div>
                                    </React.Fragment>
                                ) : (
                                    <NoDataCreated
                                        containerClassname="pos_rel"
                                        message={`There are no templates for program.!`}
                                    />
                                )}
                            </React.Fragment>
                        )}
                    </div>
                </div>
            </Dialog>
            {/*  */}


            {/* Template view modal */}
            <Dialog
                visible={showProgramTemplateViewModal}
                header={templateViewModalHeader}
                headerClassName="custom_modal_header"
                className="custom_modal_dialog modal_dialog_sm"
                onHide={handleCloseProgramTemplateViewModal}
                dismissableMask
            >
                <div className="custom_modal_body">
                    {selectedProgramTemplate && selectedProgramTemplate !== null ? (
                        <React.Fragment>
                            <div className="page_form_group px-sm-3 pt-1 mb-1">
                                <article className="payment_summary_area" id="paymentSummary">
                                    <div className="payment_summary_info">
                                        <h6>Program</h6>
                                        <p className="text_purple">{selectedProgramTemplate?.program_name}</p>
                                    </div>

                                    <div className="payment_summary_info">
                                        <h6>Type</h6>
                                        <p>
                                            {selectedProgramTemplate?.program_type}
                                        </p>
                                    </div>

                                    {selectedProgramTemplate?.program_type === 'Floor' && (
                                        <React.Fragment>
                                            <div className="payment_summary_info">
                                                <h6>No. of Basements</h6>
                                                <p>
                                                    {selectedProgramTemplate?.no_of_basement}
                                                </p>
                                            </div>

                                            <div className="payment_summary_info">
                                                <h6>No. of Floors</h6>
                                                <p>
                                                    {selectedProgramTemplate?.no_of_floor}
                                                </p>
                                            </div>
                                        </React.Fragment>
                                    )}
                                </article>
                                <div className="d-flex justify-content-end mt-2">
                                    <button
                                        className={`add_data_btn ${showTemplateUse ? 'danger' : ''} p-ripple`}
                                        onClick={handleUseTemplate}
                                    >
                                        <i className={`bi ${showTemplateUse ? 'bi-x-circle' : 'bi-check2-circle'}`}></i>
                                        {showTemplateUse ? 'Cancel' : 'Use this template'}
                                        <Ripple />
                                    </button>
                                </div>
                            </div>

                            <div className="px-sm-3">
                                <div className={`expand_input_area ${showTemplateUse ? 'expanded' : ''}`}>
                                    <DatePicker
                                        id="startDateForTemplate"
                                        label="Start date"
                                        labelHtmlFor="startDateForTemplate"
                                        required={true}
                                        value={startDateForTemplate}
                                        placeholder="dd/mm/yyyy"
                                        onChange={setStartDateForTemplate}
                                        error={startDateForTemplateError}
                                        showClear
                                        formGroupClassName="mb-3"
                                        onClear={() => setStartDateForTemplate(null)}
                                    />

                                    <div className="d-flex justify-content-end mt-2">
                                        <Button
                                            label={loading ? 'Processing' : 'Submit'}
                                            onClick={handleCreateProgramWithTemplate}
                                            loading={loading}
                                            className="custom_btn primary"
                                            disabled={startDateForTemplate === null}
                                        />
                                    </div>
                                </div>
                            </div>

                            {selectedProgramTemplate?.program_type === 'Floor' ? (
                                <React.Fragment>
                                    {selectedProgramTemplate?.detail && selectedProgramTemplate?.detail?.length > 0 ? (
                                        <React.Fragment>
                                            {selectedProgramTemplate?.detail?.map((data, index) => {
                                                return (
                                                    <div key={index + 1} className="programme_content_section">
                                                        <div className="table-responsive">
                                                            <table className="table table-sm program_table">
                                                                <thead>
                                                                    <tr className="program_table_row">
                                                                        <th style={{ width: '47%' }}>
                                                                            {data?.key}
                                                                        </th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    {data?.task_list.map((task) => {
                                                                        return (
                                                                            <tr className="program_table_row left_border" style={{ backgroundColor: task?.color_code?.color_code || '#EEE' }}>
                                                                                <td style={{ width: '47%' }}>
                                                                                    {templateTaskDetailBody(task)}
                                                                                </td>
                                                                            </tr>
                                                                        )
                                                                    })}
                                                                </tbody>
                                                            </table>
                                                        </div>
                                                        <hr className="border-secondary" />
                                                    </div>
                                                )
                                            })}
                                        </React.Fragment>
                                    ) : (
                                        <div className="px-sm-3 pt-2">
                                            <div className="feature_not_available_area">
                                                <h6>No data is available for this template.</h6>
                                            </div>
                                        </div>
                                    )}
                                </React.Fragment>
                            ) : selectedProgramTemplate?.program_type === 'General' ? (
                                <React.Fragment>
                                    {selectedProgramTemplate?.task_list && selectedProgramTemplate?.task_list?.length > 0 ? (
                                        <div className="programme_content_section mt-3">
                                            <div className="table-responsive">
                                                <table className="table table-sm program_table">
                                                    <tbody>
                                                        {selectedProgramTemplate?.task_list?.map((task) => {
                                                            return (
                                                                <tr className="program_table_row left_border" style={{ backgroundColor: task?.color_code?.color_code || '#EEE' }}>
                                                                    <td style={{ width: '47%' }}>
                                                                        {templateTaskDetailBody(task)}
                                                                    </td>
                                                                </tr>
                                                            )
                                                        })}
                                                    </tbody>
                                                </table>
                                            </div>
                                            <hr className="border-secondary" />
                                        </div>
                                    ) : (
                                        <div className="px-sm-3 pt-2">
                                            <div className="feature_not_available_area">
                                                <h6>No data is available for this template.</h6>
                                            </div>
                                        </div>
                                    )}
                                </React.Fragment>
                            ) : null}
                        </React.Fragment>
                    ) : (
                        <div className="feature_not_available_area">
                            <h6>No data found.</h6>
                        </div>
                    )}
                </div>
            </Dialog>


            {/* Custom option modal */}
            <Dialog
                visible={showCustomOptionModal}
                header={customOptionModalHeader}
                headerClassName="custom_modal_header"
                className="custom_modal_dialog modal_dialog_md"
                onHide={handleCloseCustomOptionModal}
                dismissableMask
            >
                <div className="custom_modal_body">
                    <div className="custom_option_area">
                        <div className="row">
                            <div className="col-12 col-sm-6 divide">
                                <div className="custom_option_container">
                                    <h6 className="custom_option_head">
                                        <i className="bi bi-card-checklist me-2"></i>
                                        General
                                    </h6>

                                    <p className="custom_option_desc">
                                        Lorem ipsum dolor sit amet consectetur adipisicing elit. Deserunt atque hic
                                    </p>

                                    <div className="custom_option_btn_container">
                                        <Button
                                            label="Create"
                                            icon="bi bi-chevron-right"
                                            iconPos="right"
                                            onClick={() => handleAddProgram('General')}
                                            className="custom_btn sm primary outlined"
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="col-12 col-sm-6">
                                <div className="custom_option_container">
                                    <h6 className="custom_option_head">
                                        <i className="bi bi-building me-2"></i>
                                        Floor
                                    </h6>

                                    <p className="custom_option_desc">
                                        Lorem ipsum dolor sit amet consectetur adipisicing elit. Deserunt atque hic excepturi laboriosam qui natus iure modi aperiam in similique?
                                    </p>

                                    <div className="custom_option_btn_container">
                                        <Button
                                            label="Create"
                                            icon="bi bi-chevron-right"
                                            iconPos="right"
                                            onClick={() => handleAddProgram('Floor')}
                                            className="custom_btn sm primary outlined"
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Dialog>
            {/*  */}


            {/* Program chart */}
            <ProgramChartModal
                isOpen={showProgramChartModal}
                view={programmeChartView!}
                programmeChartData={programChartData}
                projectData={projectData}
                onClose={handleCloseProgramChartModal}
                loading={loadingProgramChartData}
                error={errorProgramChartData}
            />


            {/* Message box modal */}
            <Dialog
                visible={showDiplayMessageModal}
                headerClassName="d-none"
                className="custom_modal_dialog modal_dialog_sm"
                onHide={() => { if (!showDiplayMessageModal) return; setShowDiplayMessageModal(false); }}
                dismissableMask
            >
                <div className="custom_modal_body">
                    <button className="custom_modal_close position-absolute float p-ripple"
                        onClick={() => setShowDiplayMessageModal(false)}>
                        <i className="bi bi-x-lg"></i>
                        <Ripple />
                    </button>
                    <div className="feature_unavailable_container">
                        <img src="/assets/images/no_data/no-feature.png" alt="No task(s) assigned" />
                        <h6>This feature is currently unavailable.</h6>
                    </div>
                </div>
            </Dialog>
        </React.Fragment>
    )
}

export default Programme;